import { useTheme } from '@mui/material/styles';
import React, { useState,useEffect,useMemo } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSpring, animated } from '@react-spring/web'

function NavBar() {

  const theme = useTheme();

  const mobile = useMediaQuery('(max-width:1000px)');

  const [open, setOpen] = useState(false);
  const [onTop, setOnTop] = useState(false)

  const AnimatedNav = useMemo(() => animated(AppBar),[])


  function onChange(value) {

    setOpen(!open)        
  }

  function listenToScroll () {
    if (window.scrollY > 0 && !onTop) {
      setOnTop(true)
    } else if (window.scrollY === 0 && onTop) {
      setOnTop(false)
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', listenToScroll)
  })
  const { height } = useSpring({

    height: (open ? "50px" : "0px"),

    config: {
      duration: 600
    },

  })

  const { opacity } = useSpring({

    opacity: (onTop ? "0.0" : "1.0"),

    config: {
      duration: 300
    },

  })

  const styles = useSpring({

    from: { y: (open ? -50 : 0) },
    to: { y: (open ? 0 : -100) },
    config: {
      duration: 600
    },
  })

  function Logo() {
    return (
      <Button href={mobile ? "":'./'} style={{ color: theme.palette.quinary.main, fontSize: "18px" }} onClick={ mobile ? onChange : null}>Blasphy</Button>
    )
  }

  function MenuButton({ children, ...props }) {
    return (
      <Typography m={mobile ? 0 : 1} variant="h5" component="div" sx={{ flexGrow: props.flexGrow }}>
        <Button href={props.href} style={{ color: theme.palette.quinary.main, fontSize: mobile ? "12px" : "16px" }}>{children}</Button>
      </Typography>
    )
  }

  function MenuButtons() {
    return (
      <>
        {mobile ? <></> : <MenuButton  flexGrow={1}></MenuButton>}
        <MenuButton href={'#AssetStoreProjects'} flexGrow={0}>Asset Store Projects</MenuButton>
      </>
    )
  }



	return (
    <Box  sx={{ flexGrow: 1}}>
      <AnimatedNav 
        style={{
          backgroundColor:theme.palette.secondary.main,
          opacity:opacity
        }} 
        position="fixed"
      >
        {mobile ?
          <>
            <Toolbar style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
              <Logo></Logo>
            </Toolbar>
            <animated.div style={{ ...styles}}>
              <animated.div style={{ height: height}}>
                <Toolbar style={{ display: "flex", justifyContent: "center", alignItems: "center",  }}>
                  <MenuButtons></MenuButtons> 
                </Toolbar>
              </animated.div>
            </animated.div>
          </>
          :
          <Toolbar >
            <Logo></Logo>
              <MenuButtons></MenuButtons>
          </Toolbar>
        }
      </AnimatedNav>
    </Box>

	);
}

export default NavBar;
